<template>
  <div class="dialog-wrap">
    <el-dialog title="新建调剂信息"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="85%">
      <el-form ref="formRules"
               :inline="true"
               :model="dataForm">
        <el-form-item label="选择年份"
                      prop="year">
          <el-select v-model="dataForm.year"
                     filterable
                     placeholder="请选择"
                     style="width: 320px">
            <el-option v-for="(item, index) in filter.years"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择院校"
                      prop="college">
          <el-select v-model="dataForm.college"
                     filterable
                     placeholder="请选择"
                     @change="collegeChange"
                     style="width: 320px">
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上下线状态"
                      prop="college">
          <el-switch v-model="switchValue"
                     :active-value="0"
                     :inactive-value="2"
                     active-color="#13ce66"
                     inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </el-form>
      <el-form class="create-wrap"
               ref="formRules"
               :inline="true"
               :model="dataForm"
               :rules="rules">
        <el-table :data="dataForm.list"
                  border
                  style="width: 100%"
                  :row-class-name="tableRowClassName">
          <el-table-column label="专业名称"
                           align="center"
                           width="280px"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-form-item label=""
                            :prop="`list[${scope.$index}].major`"
                            :rules="rules.major">
                <el-select v-model="scope.row.major"
                           placeholder="请选择"
                           filterable
                           clearable
                           @change="
                    (...event) => {
                      majorChange(event, scope.row);
                    }
                  ">
                  <el-option v-for="(item, index) in majorList"
                             :key="index"
                             :label="`（${item.code}）${item.name}`"
                             :value="{ value: item.code, label: item.name }">
                    <span>{{ `（${item.code}）${item.name}` }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="error-tip"
                   v-if="getErrorInfo(scope.$index)">
                {{ getErrorInfo(scope.$index) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="学院名称"
                           align="center"
                           width="230px"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-form-item label=""
                            :prop="`list[${scope.$index}].academy`"
                            :rules="rules.academy">
                <el-select v-model="scope.row.academy"
                           placeholder="请选择"
                           filterable
                           clearable
                           @change="
                    (...event) => {
                      academyChange(event, scope.row);
                    }
                  ">
                  <el-option v-for="(item, index) in scope.row.academylist"
                             :key="index"
                             :label="item.academy_name"
                             :value="{
                      value: item.academy_code,
                      label: item.academy_name,
                      directions: item.directions,
                    }">
                    <span>{{
                      `（${item.academy_code}）${item.academy_name}`
                    }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="方向名称"
                           align="center"
                           show-overflow-tooltip
                           width="230px">
            <template slot-scope="scope">
              <el-form-item label=""
                            :prop="`list[${scope.$index}].direction`"
                            :rules="rules.direction">
                <el-select v-model="scope.row.direction"
                           placeholder="请选择"
                           filterable
                           clearable>
                  <el-option v-for="(item, index) in scope.row.directionlist"
                             :key="index"
                             :label="item.direction"
                             :value="{
                      value: item.direction_code,
                      label: item.direction,
                    }">
                    <span>{{
                      `（${item.direction_code}）${item.direction}`
                    }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="学习方式"
                           align="center"
                           show-overflow-tooltip
                           width="150px">
            <template slot-scope="scope">
              <el-form-item label=""
                            :prop="`list[${scope.$index}].enrol_type`"
                            :rules="rules.enrol_type">
                <el-select v-model="scope.row.enrol_type"
                           placeholder="请选择"
                           clearable>
                  <el-option v-for="(item, index) in filter.enrol_types"
                             :key="index"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="调剂余额"
                           align="center"
                           show-overflow-tooltip
                           width="300px">
            <template slot-scope="scope">
              <div class="between">
                <el-form-item label=""
                              :prop="`list[${scope.$index}].plan_last_count`"
                              :rules="rules.plan_last_count">
                  <!-- <el-select style="width:90px"
                             v-model="scope.row.plan_last_count"
                             filterable
                             placeholder="请选择"
                             clearable
                             v-if="scope.row.plan_last_count_switch == 1">
                    <el-option label="有"
                               value="有"> </el-option>
                    <el-option label="无"
                               value="无"> </el-option>
                  </el-select>
                  <el-input-number v-model="scope.row.plan_last_count"
                                   v-if="scope.row.plan_last_count_switch == 0"
                                   :min="0"
                                   label="描述文字"></el-input-number>
                <el-switch v-model="scope.row.plan_last_count_switch"
                           active-text="有无"
                           inactive-text="人数"
                           :active-value="1"
                           :inactive-value="0"
                           @change="
                    (...event) => {
                      switchChange(event, scope.row);
                    }
                  "
                           style="margin-top: -10px">
                </el-switch> -->
                  <el-input-number v-model="scope.row.plan_last_count"
                                   :min="0"
                                   label="描述文字"></el-input-number>人数
                </el-form-item>

              </div>
            </template>
          </el-table-column>
          <el-table-column label="调剂要求"
                           align="left"
                           show-overflow-tooltip
                           width="245px">
            <template slot-scope="scope">
              <!--   <el-link
                type="primary"
                :underline="false"
                @click="openContentDialog(scope.row)"
              >填写内容</el-link> -->
              <el-form-item label=""
                            :prop="`list[${scope.$index}].adjust_demand`"
                            :rules="rules.adjust_demand">
                <el-input type="textarea"
                          style="width: 200px"
                          placeholder="请输入调剂余额"
                          v-model="scope.row.adjust_demand">
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="left"
                           show-overflow-tooltip
                           width="150px">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToAddDirection(scope.row)">添加方向</el-link>
              <el-link type="danger"
                       :underline="false"
                       @click="handleToRemove(scope.$index)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-form>

      <div slot="footer"
           class="dialog-footer">
        <el-button size="mini"
                   @click="pushList"><i class="el-icon-plus el-icon--right"></i>添加专业</el-button>
        <el-button size="mini"
                   type="danger"
                   @click="deleteErrorRows"
                   v-if="errorIndexList.length">
          <i class="el-icon-delete el-icon--right"></i>一键删除错误数据
        </el-button>
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary"
                     @click="submit('formRules')">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import { bulksingleCollege } from '@/api/adjust'

export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      switchValue: 0,
      dialogVisible: this.visible,
      dataForm: {
        year: 2025,
        list: [],
      },
      rules: {
        /*     year: [{ required: true, message: "请选择年份", trigger: "blur" }],
            college: [{ required: true, message: "请选择院校", trigger: "blur" }], */
        major: [{ required: true, message: '请选择专业', trigger: 'blur' }],
        academy: [{ required: true, message: '请选择学院', trigger: 'blur' }],
        direction: [{ required: true, message: '请选择方向', trigger: 'blur' }],
        enrol_type: [
          { required: true, message: '请选择学习方式', trigger: 'blur' },
        ],
        plan_last_count: [
          { required: true, message: '请输入或选择调剂余额', trigger: 'blur' },
        ],
        adjust_demand: [
          { required: true, message: '请输入调剂要求', trigger: 'blur' },
        ],
      },
      filter: {
        years: [
          { label: '2027年考研', value: 2027 },
          { label: '2026年考研', value: 2026 },
          { label: '2025年考研', value: 2025 },
          { label: '2024年考研', value: 2024 },
          { label: '2023年考研', value: 2023 },
          // { label: "2022年考研", value: 2022 },
          // { label: "2021年考研", value: 2021 },
        ],
        enrol_types: [
          { label: '全日制', value: 1 },
          { label: '非全日制', value: 2 },
        ],
      },
      list: [],
      majorList: [],
      spanArr1: [], // 记录每一行的合并数
      pos1: '', // 记录索引
      spanArr2: [], // 记录每一行的合并数
      pos2: '', // 记录索引,
      errorIndex: -1,
      errorIndexList: [], // 存储所有错误行下标
      errorDataList: [],
      contentDialog: false,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.dataForm.year = 2026
        this.getSpanArr(this.dataForm.list)
      }
    },
  },
  created() {},
  methods: {
    getErrorInfo(index) {
      const item = this.errorDataList.find(
        (i) => i.index_academy_major === index
      )
      return item ? item.error_msg : ''
    },
    pushList() {
      if (!this.dataForm.college || !this.dataForm.year) {
        this.$message.error('请先选择年份和院校')
        return
      }
      this.dataForm.list = this.dataForm.list.concat([
        {
          major: null,
          academy: null,
          plan_last_count_switch: 1,
          plan_last_count: '有',
        },
      ])
      this.getSpanArr(this.dataForm.list)
    },
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      this.fetchMajor(e.value)

      this.$forceUpdate()
    },
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
        if (this.dataForm.list.length <= 0) {
          this.dataForm.list.push({
            major: null,
            academy: null,
            plan_last_count_switch: 1,
            plan_last_count: '有',
          })
        }
      })
    },
    fetchAcademy(college_code, major_code) {
      return new Promise((resolve, reject) => {
        academyList({ college_code, major_code, isPaging: 0 }).then((res) => {
          resolve(res.list)
        })
      })
    },
    handleClose() {
      this.dataForm = {
        list: [],
      }
      this.errorIndexList = []
      this.errorDataList = []
      this.$emit('close')
    },

    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          if (!this.dataForm.list.length) {
            this.$message.error('请添加专业')
            return
          }
          const data = {
            _delete: this.switchValue,
            college_code: this.dataForm.college.value,
            college_name: this.dataForm.college.label,
            year: this.dataForm.year,
            arr_academy_major: this.dataForm.list.map((v) => {
              return {
                academy_code: v.academy.value,
                academy_name: v.academy.label,
                major_code: v.major.value,
                major_name: v.major.label,
                arr_direction_data: [
                  {
                    direction_code: v.direction.value,
                    direction_name: v.direction.label,
                    enrol_type: v.enrol_type,
                    plan_last_count:
                      v.plan_last_count > 0 ? v.plan_last_count : '有',
                    adjust_demand: v.adjust_demand,
                  },
                ],
              }
            }),
          }
          bulksingleCollege(data).then((res) => {
            if (res == null) {
              this.errorIndex = -1
              this.handleClose()
              this.$emit('submit')
              this.$message.success('创建成功')
            } else {
              // let err = JSON.parse(res)
              // console.log('err', err)
              // this.errorIndex = err.err_data.index_direction

              let errorMsg = res
              // this.$message.error(errorMsg)
              const jsonMatch = errorMsg.match(/缺额全部错误数据：(\[.+\])/)
              if (jsonMatch && jsonMatch[1]) {
                const errorDataList = JSON.parse(jsonMatch[1])
                this.errorDataList = errorDataList
                this.errorIndexList = errorDataList.map(
                  (item) => item.index_academy_major
                )
              } else {
                this.$message.error('未获取到错误数据')
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    tableRowClassName({ row, rowIndex }) {
      // if (rowIndex == this.errorIndex) {
      //   console.log(this.errorIndex)
      //   console.log(rowIndex)
      //   return 'warning-row'
      // }
      if (this.errorIndexList.includes(rowIndex)) {
        return 'warning-row'
      }
      return ''
    },
    async majorChange(params, row) {
      this.$set(row, 'academy', null)
      let obj = await this.fetchMajorInfo(
        this.dataForm.college.value,
        params[0].value
      )
      this.$set(row, 'academylist', obj.academys)

      if (obj.academys && obj.academys.length) {
        this.$set(row, 'academy', {
          value: obj.academys[0].academy_code,
          label: obj.academys[0].academy_name,
          directions: obj.academys[0].directions,
        })
        // console.log("lll",obj.academys[0].directions)
        if (obj.academys[0].directions && obj.academys[0].directions.length) {
          this.$set(row, 'directionlist', obj.academys[0].directions)
          this.$set(row, 'direction', {
            label: obj.academys[0].directions[0].direction,
            value: obj.academys[0].directions[0].direction_code,
          })
        }
      }

      this.$set(row, 'enrol_type', 1)
      // console.log("obj.academys",obj.academys)
      this.$forceUpdate()
    },
    fetchMajorInfo(college_code, major_code) {
      return new Promise((resolve, reject) => {
        majorinfo({ college_code, major_code, isPaging: 0 }).then((res) => {
          resolve(res)
        })
      })
    },
    academyChange(params, row) {
      this.$set(row, 'directionlist', params[0].directions)

      this.$forceUpdate()
    },
    switchChange(params, row) {
      if (params[0] == 0) {
        this.$set(row, 'plan_last_count', '')
      } else if (params[1] == 1) {
        this.$set(row, 'plan_last_count', 1)
      }
      this.$forceUpdate()
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      console.log(rowIndex)
      if (columnIndex === 0) {
        // 第一列
        const _row = this.spanArr1[rowIndex]
        const _col = _row > 0 ? 1 : 0
        console.log({
          rowspan: _row,
          colspan: _col,
        })
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      if (columnIndex === 1) {
        // 第二列
        const _row = this.spanArr2[rowIndex]
        const _col = _row > 0 ? 1 : 0
        console.log({
          rowspan: _row,
          colspan: _col,
        })
        return {
          rowspan: _row,
          colspan: _col,
        }
      }

      if (rowIndex === 0 && columnIndex < 2) {
        //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0, //清除就是这俩属性设置为0
        }
      }
    },

    getSpanArr(data) {
      for (let i = 0; i < data.length; i++) {
        // 第一列
        if (i === 0) {
          this.spanArr1.push(1)
          this.pos1 = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (
            data[i].major &&
            data[i].major.value === data[i - 1].major.value
          ) {
            this.spanArr1[this.pos1] += 1
            this.spanArr1.push(0)
          } else {
            this.spanArr1.push(1)
            this.pos1 = i
          }
        }
      }
      for (let i = 0; i < data.length; i++) {
        // 第二列
        if (i === 0) {
          this.spanArr2.push(1)
          this.pos2 = 0
        } else {
          // 判断当前元素与上一个元素是否相同data[i].major.value === data[i - 1].major.value
          if (
            data[i].academy &&
            data[i].academy.value === data[i - 1].academy.value
          ) {
            this.spanArr2[this.pos2] += 1
            this.spanArr2.push(0)
          } else {
            this.spanArr2.push(1)
            this.pos2 = i
          }
        }
      }
    },
    handleToAddDirection(row) {
      if (row.major) {
        this.dataForm.list = this.dataForm.list.concat([
          {
            major: row.major,
            academy: row.academy,
            plan_last_count_switch: 1,
            academylist: row.academylist,
            directionlist: row.directionlist,
          },
        ])
      } else {
        this.$message.error('请选择专业与学院')
      }
      this.getSpanArr(this.dataForm.list)
    },
    handleToRemove(index) {
      this.dataForm.list.splice(index, 1)
    },
    openContentDialog(row) {
      this.contentDialog = true
    },

    deleteErrorRows() {
      if (this.errorIndexList.length === 0) return

      // 倒序删除，防止下标错乱
      const errorIndexes = [...this.errorIndexList].sort((a, b) => b - a)
      errorIndexes.forEach((index) => {
        this.dataForm.list.splice(index, 1)
      })

      this.$message.success('已删除所有错误数据')
      this.errorIndexList = []
      this.errorDataList = []
      this.getSpanArr(this.dataForm.list)
    },
  },
}
</script>
  
  <style lang="less">
.error-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
  text-align: center;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.between {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}

.el-table .warning-row {
  background-color: #ffbfbf !important;
}

.el-table .success-row {
  background-color: #f0f9eb;
}
.create-wrap {
  .el-input__inner {
    border: none;
  }
}
</style>
  